// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:599px){#wrapper[data-v-35c943e6]{padding:0 0 20px 0;margin-left:10px}}@media screen and (max-width:440px){#wrapper[data-v-35c943e6]{padding:0 0 10px 0;margin-left:0}}", ""]);
// Exports
module.exports = exports;
